import ApiService from 'core/api/api.service';
import { ButtonType } from 'core/enums/button-type';
import { useDialog } from 'core/providers/DialogProvider';
import { ref } from 'firebase/storage';
import { useEffect, useState } from 'react';
import SharedDialogBase from 'shared/components/dialog-base/dialog-base';
import { ISharedDialogButton } from 'shared/components/dialog-base/dialog-base-interface';
import { storage } from 'core/config/firebase';

const ViewImageDialog = ({ imagePath }: { imagePath: string }) => {
  const dialog = useDialog();

  const customButtons: ISharedDialogButton[] = [
    {
      key: 'close',
      type: ButtonType.Button,
      buttonProps: {
        onClick: () => dialog?.closeDialog(),
        appearance: 'primary',
        label: 'Close',
        type: 'button',
      },
    },
  ];

  const [imageUrl, setImageUrl] = useState<string>();

  useEffect(() => {
    const getImageUrl = async () => {
      const url = await ApiService.getFileDownloadUrl(ref(storage, imagePath));
      setImageUrl(url);
    };

    getImageUrl();
  }, [imagePath]);

  return (
    <SharedDialogBase
      title='View Image'
      customContentTemplate={<img src={imageUrl} alt='Damage Report' />}
      customButtons={customButtons}
    />
  );
};

export default ViewImageDialog;
